var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pnl_box"},[_c('div',{staticClass:"pnl_label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"pnl_value",class:_vm.color_class},[_vm._v(" "+_vm._s(_vm.str_val)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }